<template>
    <div class="page-wrapper">
        <div class="cg-main-title">个人设置</div>
        <div class="tabBox">
           <div class="tabItem" @click="toggleTab(1)" :class="{active:tab==1}">企业信息</div>
           <div class="tabItem"  @click="toggleTab(2)" :class="{active:tab==2}">修改密码</div>
        </div>
        <user-info v-if="tab == 1" />
        <edit-password v-if="tab == 2" />
    </div>
</template>

<script>
import userInfo from './user-info'
import editPassword from './edit-password'
export default {
    components: {
        userInfo,
        editPassword
    },
    data() {
        return {
            tab: '1'
        }
    },
    created() {
       
    },
    methods: {
        toggleTab(val) {
            this.tab = val
        },
    }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 0px 24px 24px;
  min-width: 900px;
}
.tabBox{
    .tabItem{font-size: 16px;display: inline-block;padding:12px 0;margin:16px 33px 16px 0;cursor: pointer;}
    .tabItem.active{color:#F81D22;border-bottom: 2px solid #F81D22;font-weight: bold;}
}
.infoWrap{
    color:#000; background: #fff;padding:24px;
    .title{
        height: 64px;line-height: 64px;font-size: 16px;opacity:0.85;font-weight: bold; position: relative;
        .icon{width: 15px;height: 15px; margin-left:14px; vertical-align: middle;}
        .rightBtn{position: absolute;top:0;right:24px;
            button{width: 44px;height: 24px;padding:0;border-radius: 2px;}
        }
    }
    .content{
        border-bottom:1px solid #eee;padding-bottom: 26px;
        .brand-wrap {
            width: 80%;
            .mylabel {
                margin-bottom: 8px;
            }
        }
        .oneItem{
            display: inline-block;width: 33%;margin-bottom: 16px;
            .mylabel{opacity:0.85;margin-right: 6px;}
            .text{opacity:0.65;}
        }
    }
    .content:last-child{border-bottom: 0;}
}
.no-address-list {
    color: rgba(0, 0, 0, 0.85);
}
.address-list {
    .address-item {
        position: relative;
        padding: 15px 0;
        border-bottom:  1px solid #eee;
        &:first-child {
            padding-top: 0;
        }
        .edit {
            position: absolute;
            right: 40px;
            top: 25px;
        }
        .icon {
            width: 15px;
            height: 15px;
            cursor: pointer;
        }
    }
    
    .block-item {
        display: block;
        margin-bottom: 4px;
    }
    .span-item {
        float: left;
        width: 33.3%;
    }
    .default {
        background: #999;
        color: #fff;
        padding: 0 10px;
        margin-left: 32px;
    }
    .label {
        color: rgba(0, 0, 0, 0.85); margin-right: 6px;
    }
    .text {
        color: rgba(0, 0, 0, 0.65);
    }
}

.add-address-wrap {
    width: 550px;
    margin: 0 auto;
}

</style>